// -- Shared audio helper ------------------------------------------------------
// A single AudioContext is created once and reused for all chimes.

let _audioCtx = null;

function _getAudioCtx() {
  if (!_audioCtx) {
    try { _audioCtx = new (window.AudioContext || window.webkitAudioContext)(); }
    catch (e) { return null; }
  }
  return _audioCtx;
}

function _unlockAudio() {
  const ctx = _getAudioCtx();
  if (ctx && ctx.state === "suspended") ctx.resume().catch(() => {});
  // Self-remove after first user interaction — no need to keep listening once unlocked.
  document.removeEventListener("click",   _unlockAudio);
  document.removeEventListener("keydown",  _unlockAudio);
  document.removeEventListener("touchend", _unlockAudio);
}

if (typeof document !== "undefined") {
  document.addEventListener("click",   _unlockAudio, { passive: true });
  document.addEventListener("keydown",  _unlockAudio, { passive: true });
  document.addEventListener("touchend", _unlockAudio, { passive: true });
}

function _playNotes(notes) {
  try {
    const ctx = _getAudioCtx();
    if (!ctx) return;
    const play = () => {
      notes.forEach(({ freq, vol = 0.12, type = "sine", attack = 0.015, decay = 0.5, delay = 0 }) => {
        const osc  = ctx.createOscillator();
        const gain = ctx.createGain();
        osc.connect(gain);
        gain.connect(ctx.destination);
        osc.type = type;
        const t = ctx.currentTime + delay;
        osc.frequency.setValueAtTime(freq, t);
        gain.gain.setValueAtTime(0, t);
        gain.gain.linearRampToValueAtTime(vol, t + attack);
        gain.gain.exponentialRampToValueAtTime(0.0001, t + decay);
        osc.start(t);
        osc.stop(t + decay);
      });
    };
    if (ctx.state === "suspended") { ctx.resume().then(play); } else { play(); }
  } catch (e) { /* audio not available */ }
}

export function playMessageChime(urgent = false) {
  if (urgent) {
    // Urgent: 3 descending triangle tones — assertive but not jarring
    _playNotes([
      { freq: 987, vol: 0.22, type: "triangle", attack: 0.008, decay: 0.32, delay: 0.00 },
      { freq: 830, vol: 0.20, type: "triangle", attack: 0.008, decay: 0.32, delay: 0.15 },
      { freq: 698, vol: 0.18, type: "triangle", attack: 0.008, decay: 0.32, delay: 0.30 },
    ]);
  } else {
    // Normal message: 2 ascending sine tones — soft, modern, like a gentle ping
    _playNotes([
      { freq: 660, vol: 0.11, type: "sine", attack: 0.018, decay: 0.55, delay: 0.00 },
      { freq: 880, vol: 0.09, type: "sine", attack: 0.018, decay: 0.55, delay: 0.16 },
    ]);
  }
}

export function playEntryChime() {
  // New connection card: 3-note ascending soft chime — bright, welcoming
  _playNotes([
    { freq: 523, vol: 0.08, type: "sine", attack: 0.02, decay: 0.5, delay: 0.00 },
    { freq: 659, vol: 0.08, type: "sine", attack: 0.02, decay: 0.5, delay: 0.13 },
    { freq: 784, vol: 0.07, type: "sine", attack: 0.02, decay: 0.6, delay: 0.26 },
  ]);
}
